import { formatDateRu, formatTimeRu } from "./appointmentLabels";

export function toDatetimeLocalValue(d) {
  if (!d || Number.isNaN(new Date(d).getTime())) return "";
  const date = d instanceof Date ? d : new Date(d);
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function defaultScheduledSendAt() {
  const d = new Date();
  d.setMinutes(d.getMinutes() + 60, 0, 0);
  return toDatetimeLocalValue(d);
}

export function buildDatetimePresets(baseDate = new Date()) {
  const now = new Date(baseDate);
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const tomorrowAt = (h, m = 0) => {
    const d = new Date(tomorrow);
    d.setHours(h, m, 0, 0);
    return d;
  };

  return [
    { id: "now", label: "Сейчас", getDate: () => new Date() },
    { id: "1h", label: "Через 1 ч", getDate: () => new Date(now.getTime() + 3600000) },
    { id: "2h", label: "Через 2 ч", getDate: () => new Date(now.getTime() + 7200000) },
    { id: "3h", label: "Через 3 ч", getDate: () => new Date(now.getTime() + 10800000) },
    { id: "tomorrow9", label: "Завтра 9:00", getDate: () => tomorrowAt(9) },
    { id: "tomorrow12", label: "Завтра 12:00", getDate: () => tomorrowAt(12) },
    { id: "tomorrow18", label: "Завтра 18:00", getDate: () => tomorrowAt(18) },
  ];
}

export const POLL_TRIGGER_OPTIONS = [
  {
    id: "immediate",
    label: "Сейчас",
    hint: "Отправить клиентам сразу после создания",
  },
  {
    id: "scheduled",
    label: "Ко времени",
    hint: "Запланировать отправку на дату и время",
  },
  {
    id: "before_session",
    label: "Перед тренировкой",
    hint: "Автоматически за N часов до каждого занятия",
  },
  {
    id: "after_session",
    label: "После тренировки",
    hint: "Автоматически через N часов после занятия",
  },
];

export const HOURS_BEFORE_OPTIONS = [
  { value: 1, label: "1 час" },
  { value: 2, label: "2 часа" },
  { value: 4, label: "4 часа" },
  { value: 6, label: "6 часов" },
  { value: 12, label: "12 часов" },
  { value: 24, label: "24 часа" },
];

export const HOURS_AFTER_OPTIONS = [
  { value: 1, label: "1 час" },
  { value: 2, label: "2 часа" },
  { value: 4, label: "4 часа" },
  { value: 6, label: "6 часов" },
  { value: 12, label: "12 часов" },
];

export function inferTriggerType(poll) {
  if (poll?.trigger_type) return poll.trigger_type;
  if (poll?.send_mode === "auto") return "before_session";
  if (poll?.scheduled_send_at) {
    const sched = new Date(poll.scheduled_send_at);
    const sent = Number(poll.stats?.sent || 0) > 0;
    if (!sent && !Number.isNaN(sched.getTime()) && sched > new Date()) {
      return "scheduled";
    }
  }
  return "immediate";
}

export function pollTriggerLabel(poll) {
  const t = inferTriggerType(poll);
  switch (t) {
    case "scheduled":
      if (poll.scheduled_send_at) {
        const sent = Number(poll.stats?.sent || 0) > 0;
        if (sent) return "Отправлен по расписанию";
        return `Отправка ${formatDateRu(poll.scheduled_send_at)} ${formatTimeRu(poll.scheduled_send_at)}`;
      }
      return "По расписанию";
    case "before_session":
      return `Перед тренировкой · за ${poll.hours_before || 2} ч`;
    case "after_session":
      return `После тренировки · через ${poll.hours_after || 1} ч`;
    default:
      return "Разовая отправка";
  }
}

export function isScheduledInFuture(scheduledSendAt) {
  if (!scheduledSendAt) return false;
  const d = new Date(scheduledSendAt);
  return !Number.isNaN(d.getTime()) && d > new Date();
}
